import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Home from "./page.tsx";
import "./globals.css";
import { rememberLanguage, resolveLanguage } from "./i18n";

// Before the first paint, so a screen reader and the browser's own UI agree with
// what is on screen.
rememberLanguage(resolveLanguage());

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <Home />
  </StrictMode>,
);
